// OrgWhitelist

export default class OrgWhitelist {
    constructor(guest_phone, comments, from_date, to_date) {
        this.guest_phone = guest_phone;
        this.comments = comments;
        this.from_date = from_date;
        this.to_date = to_date;
    }
}